import React from 'react';
import { useSelector } from 'react-redux';
import TextEllipsis from '../../../text/TextEllipsis';
import globalConfig from '../../../../config/globalConfig';

const TenantInfo = () => {
  const tenant = useSelector((state) => state?.tenant?.tenant || {});
  return (
    <div className='flex justify-end items-center gap-4 px-4 min-w-180px'>
      <div className='header-institute-info-right'>
        <img src={`${globalConfig.storage}${tenant.logoUrl}`} alt='institute_logo' />
      </div>
        <div className='flex flex-col gap-1'>
          {!tenant.hideName && <TextEllipsis className='font-bold'>{tenant?.name}</TextEllipsis>}
          {!tenant.hideAddress && <TextEllipsis>{tenant?.address}</TextEllipsis>}
        </div>
    </div>
  );
};

export default TenantInfo;
